// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContentNotFound_container__M8kfe {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    width: 100%;
    padding: 20px;
  }
  
  .ContentNotFound_content__k1MJb {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 500px;
    padding: 30px;
    border-radius: 8px;
    background-color: black;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  
  .ContentNotFound_icon__ZijY\\+ {
    color: #f59e0b;
    margin-bottom: 16px;
  }
  
  .ContentNotFound_title__l55bO {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 12px 0;
    color: white;
  }
  
  .ContentNotFound_description__iKVsg {
    font-size: 16px;
    line-height: 1.5;
    color: #6b7280;
    margin-bottom: 24px;
  }
  
  .ContentNotFound_refreshButton__jMOy7 {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background-color: red;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .ContentNotFound_refreshButton__jMOy7:hover {
    background-color: #2563eb;
  }
  
  .ContentNotFound_refreshIcon__hIkcM {
    animation: ContentNotFound_spin__fEYL9 2s linear infinite paused;
  }
  
  .ContentNotFound_refreshButton__jMOy7:hover .ContentNotFound_refreshIcon__hIkcM {
    animation-play-state: running;
  }
  
  @keyframes ContentNotFound_spin__fEYL9 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @media (max-width: 640px) {
    .ContentNotFound_content__k1MJb {
      padding: 20px;
    }
    
    .ContentNotFound_title__l55bO {
      font-size: 20px;
    }
    
    .ContentNotFound_description__iKVsg {
      font-size: 14px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/ContentNotFound.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gEAAyC;EAC3C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    width: 100%;\n    padding: 20px;\n  }\n  \n  .content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    max-width: 500px;\n    padding: 30px;\n    border-radius: 8px;\n    background-color: black;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  }\n  \n  .icon {\n    color: #f59e0b;\n    margin-bottom: 16px;\n  }\n  \n  .title {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n    color: white;\n  }\n  \n  .description {\n    font-size: 16px;\n    line-height: 1.5;\n    color: #6b7280;\n    margin-bottom: 24px;\n  }\n  \n  .refreshButton {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    background-color: red;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .refreshButton:hover {\n    background-color: #2563eb;\n  }\n  \n  .refreshIcon {\n    animation: spin 2s linear infinite paused;\n  }\n  \n  .refreshButton:hover .refreshIcon {\n    animation-play-state: running;\n  }\n  \n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  @media (max-width: 640px) {\n    .content {\n      padding: 20px;\n    }\n    \n    .title {\n      font-size: 20px;\n    }\n    \n    .description {\n      font-size: 14px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContentNotFound_container__M8kfe`,
	"content": `ContentNotFound_content__k1MJb`,
	"icon": `ContentNotFound_icon__ZijY+`,
	"title": `ContentNotFound_title__l55bO`,
	"description": `ContentNotFound_description__iKVsg`,
	"refreshButton": `ContentNotFound_refreshButton__jMOy7`,
	"refreshIcon": `ContentNotFound_refreshIcon__hIkcM`,
	"spin": `ContentNotFound_spin__fEYL9`
};
export default ___CSS_LOADER_EXPORT___;
